import { render, staticRenderFns } from "./NewToken.vue?vue&type=template&id=376e72a4&scoped=true&"
import script from "./NewToken.vue?vue&type=script&lang=js&"
export * from "./NewToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376e72a4",
  null
  
)

export default component.exports